module.exports = __webpack_public_path__ + "static/media/long-marton-rail.022bd00b.jpg";